import request from '../../Request';
import AppConfig from 'qs-config/AppConfig';

export const getShippingWeightUnits = () =>
  request.authGet(`${AppConfig.qsApiEndPoint}/v1/shipping-cost/weight`);
